// extracted by mini-css-extract-plugin
module.exports = {"container":"payment-button_container__vxggB"};